import { heroImage, siteStats } from '@/mocks/news';

export default function HeroSection() {
  return (
    <section id="top" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 py-12 md:py-20 items-center max-w-[1200px] mx-auto">
          {/* 文案优先 */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
              <i className="ri-bookmark-3-line" aria-hidden="true"></i>
              工具型单页速览 · 一屏追完全部进展
            </span>

            <h2 className="mt-6 font-heading text-3xl md:text-5xl lg:text-[56px] font-black leading-[1.15] text-foreground-950 text-balance">
              黑料网1最新更新
              <br />
              今日头条与新料快讯
              <span className="text-primary-600">滚动同步</span>
            </h2>

            <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-foreground-700">
              黑料网1更新页把实时滚动、今日头条与快讯整理在同一条时间线上。蹲最新进展、看今日热搜，
              来黑料网1就能抓到刚出的瓜；每条新料都按专题归档，翻起来比刷信息流更快。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#headline"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-base" aria-hidden="true"></i>
                看今日头条
              </a>
              <a
                href="#flash"
                className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-background-100 border border-background-200 text-foreground-900 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-refresh-line text-base" aria-hidden="true"></i>
                刷新新料快讯
              </a>
            </div>

            {/* 统计条 */}
            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 border-t border-background-200 pt-6">
              {siteStats.map((stat) => (
                <div key={stat.label} className="flex flex-col">
                  <dt className="text-xs text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">
                    {stat.value}
                    <span className="ml-1 text-sm font-normal text-foreground-500">{stat.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 视觉陪衬 */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative mx-auto max-w-[420px] w-full">
              <div className="absolute -inset-3 rounded-2xl bg-accent-100/70" aria-hidden="true"></div>
              <div className="relative w-full aspect-[4/5] overflow-hidden rounded-xl border border-background-200">
                <img
                  src={heroImage}
                  alt="黑料网1 今日头条与快讯速览封面插画"
                  title="黑料网1最新更新今日头条速览"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 left-4 right-4 rounded-lg bg-background-50 border border-background-200 px-4 py-3 flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-history-line" aria-hidden="true"></i>
                </span>
                <p className="text-xs leading-relaxed text-foreground-700">
                  <strong className="text-foreground-950">每 3 分钟</strong> 自动整理一轮新料，
                  黑料网1最新条目优先排到顶部。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}